module.exports = __webpack_public_path__ + "img/business-blueprint_bg.92cf0575.png";